import React from "react";
import style from "../woundAssessment.module.scss";
import { useAssessmentHistory } from "./hooks/useAssessmentHistory";
import { Modal } from "../../../secondary";
import { LockUnlockConfirmDialog } from "./LockUnlockConfirmDialog";
import { NewWoundConfirmDialog } from "./NewWoundConfirmDialog";
import { WoundGroup } from "./WoundGroup";
import { DeleteConfirmDialog } from "./DeleteConfirmDialog";
import { PdfDownloadDialog } from "./PdfDownloadDialog";
import { Spinner } from "../../../secondary/Loader/Spinner";

export const AssessmentHistory = ({
  modalOpen,
  modalTitlteId,
  setmodalShow,
  deleteAssessment,
  deleteHistoryAssessment,
  childLevelDelete,
  setChildLevelDelete,
  setNewWoundOptionChildLevel,
  modalType,
}) => {
  const hook = useAssessmentHistory({
    modalTitlteId,
    setmodalShow,
    deleteAssessment,
    deleteHistoryAssessment,
    childLevelDelete,
    setChildLevelDelete,
    setNewWoundOptionChildLevel,
    modalType,
  });

  const threeDotMenuProps = {
    wrapperRef: hook.wrapperRef,
    hoverUnlockIcon: hook.hoverUnlockIcon,
    setHoverUnlockIcon: hook.setHoverUnlockIcon,
    hoverMergeIcon: hook.hoverMergeIcon,
    setHoverMergeIcon: hook.setHoverMergeIcon,
    hoverTransferIcon: hook.hoverTransferIcon,
    setHoverTransferIcon: hook.setHoverTransferIcon,
    hoverNewWound: hook.hoverNewWound,
    setHoverNewWound: hook.setHoverNewWound,
    hoverDeleteIcon: hook.hoverDeleteIcon,
    setHoverDeleteIcon: hook.setHoverDeleteIcon,
    lockUnlockToggle: hook.lockUnlockToggle,
    lockUnlockToggleLockedOne: hook.lockUnlockToggleLockedOne,
    lockUnlockToggleLockedZero: hook.lockUnlockToggleLockedZero,
    changeLockUnlockLockedOnePopup: hook.changeLockUnlockLockedOnePopup,
    changeLockUnlockLockedZeroPopup: hook.changeLockUnlockLockedZeroPopup,
    onClickToggleLockUnlock: hook.onClickToggleLockUnlock,
    onMergeChange: hook.onMergeChange,
    onTransferChange: hook.onTransferChange,
    onNewWoundCreatePopup: hook.onNewWoundCreatePopup,
    openDeleteConfirmation: hook.openDeleteConfirmation,
  };

  return (
    <>
      <Modal modalOpen={modalOpen} modalClose={hook.modalRefresh} modalSize={style.custom_modal_size} pdfModal={hook.pdfModal}>
        <div className={style.parent}>
          <div>
            <div className={`${style.modal_heading} pl-4 pt-3 mt-3`}>Assessment History</div>
            {hook.deleteAdminChildStatus && (
              <div className={`alert alert-success ${style.form_alert} ${style.deleteToastMsg}`}>{"Wound deleted successfully"}</div>
            )}
            {hook.lockUnlockToastMsg && hook.detailAssessment?.locked === 1 && (
              <div className={`alert alert-success ${style.form_alert} ${style.deleteToastMsg}`}>{"Wound has been locked"}</div>
            )}
            {hook.lockUnlockToastMsg && hook.detailAssessment?.locked === 0 && (
              <div className={`alert alert-success ${style.form_alert} ${style.deleteToastMsg}`}>{"Wound has been unlocked"}</div>
            )}
          </div>
          <button type="button" className={!hook.pdfModal && `close ${style.close_icon}`} onClick={hook.modalRefresh}>
            &times;
          </button>
          <br />
          {hook.loading ? (
            <Spinner />
          ) : (
            <>
              {hook.lockUnlockToggleLockedOnePopup && hook.toggleClicked && (
                <LockUnlockConfirmDialog
                  isLocked={hook.lockUnlockToggleLockedOne}
                  onClose={() => hook.setLockUnlockToggleLockedOnePopup(false)}
                  onConfirm={hook.lockUnlockConfirmation}
                />
              )}

              {hook.lockUnlockToggleLockedZeroPopup && hook.toggleClicked && (
                <LockUnlockConfirmDialog
                  isLocked={hook.lockUnlockToggleLockedZero}
                  onClose={() => hook.setLockUnlockToggleLockedZeroPopup(false)}
                  onConfirm={hook.lockUnlockConfirmation}
                />
              )}

              {hook.onNewWoundCreateConfirm && (
                <NewWoundConfirmDialog onClose={() => hook.setOnNewWoundCreateConfirm(false)} onConfirm={hook.onNewWoundCreate} />
              )}

              {hook.assessmnetHistoryData?.followuphistory?.length !== 0 ? (
                <>
                  {hook.assessmnetHistoryData?.followuphistory?.map((item, parentIndex) => (
                    <WoundGroup
                      key={item?.woundTitle}
                      item={item}
                      parentIndex={parentIndex}
                      patientData={hook.patientData}
                      historyCause={hook.historyCause}
                      consolidatePdfLoading={hook.consolidatePdfLoading}
                      selectedIdsByWound={hook.selectedIdsByWound}
                      getAllMatchingChildIds={hook.getAllMatchingChildIds}
                      handleSelectAll={hook.handleSelectAll}
                      handleSelectOne={hook.handleSelectOne}
                      handleDownloadConsolidatePDF={hook.handleDownloadConsolidatePDF}
                      woundProgress={hook.woundProgress}
                      assessmentStageGetter={hook.assessmentStageGetter}
                      detaileView={hook.detaileView}
                      pdfmodalopen={hook.pdfmodalopen}
                      setHistoryId={hook.setHistoryId}
                      hasAccess={hook.hasAccess}
                      clickThreeDots={hook.clickThreeDots}
                      openTooltip={hook.openTooltip}
                      threeDotPanelClick={hook.threeDotPanelClick}
                      threeDotMenuProps={threeDotMenuProps}
                    />
                  ))}
                </>
              ) : (
                <h4 className="text-center p-4">No data available.</h4>
              )}
            </>
          )}
        </div>
      </Modal>

      {hook.showDeleteConfirmation && (
        <DeleteConfirmDialog
          assessTitleContent={hook.assessTitleContent}
          onClose={() => hook.setShowDeleteConfirmation(false)}
          onConfirm={hook.handleDelete}
        />
      )}

      {hook.pdfModal && (
        <PdfDownloadDialog
          historyId={hook.historyId}
          onClose={hook.pdfmodalclose}
          onWithImages={hook.pdfPageTrue}
          onWithoutImages={hook.pdfPageFalse}
        />
      )}
    </>
  );
};
